import styled, { keyframes } from 'styled-components';

const borderPulse = keyframes`
	0%, 100% { border-color: ${`#22c55e`}; }
	50% { border-color: transparent; }
`;

interface BaseProps {
	$x?: number;
	$y?: number;
}

export const Base = styled.div<BaseProps>`
	position: fixed;
	${({ $x, $y }) =>
		$x !== undefined && $y !== undefined
			? `left: ${$x}px; top: ${$y}px;`
			: `bottom: 12px; right: 12px;`}
	z-index: 9999;
	padding: 6px 10px;
	background: ${({ theme }) => theme.gray[0]}DD;
	border: 1px solid #22c55e;
	border-radius: 6px;
	font-size: 11px;
	color: ${({ theme }) => theme.gray[600]};
	user-select: none;
	display: flex;
	flex-direction: column;
	gap: 2px;
	animation: ${borderPulse} 2s ease-in-out infinite;
`;

export const Title = styled.div`
	font-size: 10px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	color: #22c55e;
	margin-bottom: 2px;
`;

export const Row = styled.div`
	display: flex;
	gap: 6px;
`;

export const Label = styled.span`
	color: ${({ theme }) => theme.gray[400]};
`;

export const Value = styled.span`
	color: ${({ theme }) => theme.gray[800]};
`;
